(() => {
  const section = document.getElementById('SlkMatchingAccessories');
  if (!section) return;
  const list = section.querySelector('[data-matching-list]');
  const cartLink = section.querySelector('[data-open-cart]');
  cartLink.addEventListener('click', event => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.show !== 'function') return;
    event.preventDefault();
    drawer.show(cartLink);
  });
  let loaded = false;
  let loading;
  const load = () => {
    if (loaded) return Promise.resolve(true);
    if (loading) return loading;
    loading = fetch(section.dataset.url, { signal: AbortSignal.timeout(4000) })
      .then(response => {
        if (!response.ok) throw new Error('Recommendations unavailable');
        return response.text();
      })
      .then(html => {
        const result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-matching-results]');
        if (!result || !result.querySelector('[data-matching-product]')) return false;
        if (!/^\d+$/.test(section.dataset.productId || '')) return false;
        for (const input of result.querySelectorAll('[data-source-product]')) {
          input.value = section.dataset.productId;
          input.disabled = false;
        }
        for (const input of result.querySelectorAll('[data-source-title]')) {
          input.value = section.dataset.productTitle || '';
          input.disabled = false;
        }
        list.replaceChildren(...result.childNodes);
        loaded = true;
        return true;
      })
      .catch(() => false)
      .finally(() => { loading = null; });
    return loading;
  };
  window.SlkMatchingAccessories = {
    async afterAdd(product, form, cart) {
      const card = form.closest('[data-matching-product]');
      const isPilot = String(product.product_id) === section.dataset.productId;
      if (!isPilot && !card) return false;
      if (form.closest('quick-view-modal') || document.querySelector('cart-drawer[open]')) return false;
      if (card) {
        const button = card.querySelector('[type="submit"]');
        button.querySelector('.btn__text').textContent = section.dataset.inCart;
        button.setAttribute('aria-label', section.dataset.inCart + ' ' + (product.product_title || product.title || ''));
        button.disabled = true;
        card.querySelector('.slk-matching-actions').disabled = true;
        return true;
      }
      if (!await load()) return false;
      const inCart = new Set((cart.items || []).map(item => String(item.product_id)));
      for (const candidate of list.querySelectorAll('[data-matching-product]')) {
        candidate.hidden = inCart.has(candidate.dataset.matchingProduct);
      }
      if (![...list.querySelectorAll('[data-matching-product]')].some(candidate => !candidate.hidden)) return false;
      section.querySelector('[data-added-title]').textContent = product.product_title || product.title || '';
      section.hidden = false;
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      const header = document.querySelector('sticky-header') || document.querySelector('header');
      const headerHeight = header ? Math.min(header.getBoundingClientRect().height, 220) : 140;
      const top = window.scrollY + section.getBoundingClientRect().top - headerHeight - 16;
      window.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
      return true;
    }
  };
  load();
})();
